import { useMemo, useState } from 'react';
import type { Epic } from '../../../../../api/tasks-client/task-client.type';

/**
 * Hook to search and filter epics
 * @param {Epic[]} epics Array of epics to search through
 * @returns {filteredEpics: Epic[]; handleSearchChange: (value: string) => void} Object containing filtered epics and search handler
 */
function useEpicsSearch(epics: Epic[]): { filteredEpics: Epic[]; handleSearchChange: (value: string) => void } {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredEpics = useMemo(() => {
    if (!searchTerm) {
      return epics;
    }

    const term = searchTerm.toLowerCase();
    return epics.filter(
      (epic) => epic.name.toLowerCase().includes(term) || epic.projects?.[0]?.name?.toLowerCase().includes(term),
    );
  }, [epics, searchTerm]);

  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
  };

  return { filteredEpics, handleSearchChange };
}

export { useEpicsSearch };
